import { alpha } from "@mui/material/styles"

export const styles = {
  baseCard: (theme) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1.5,
    borderRadius: "12px",
    padding: "10px 16px",
    border: `1px solid ${theme.palette.divider}`,
    flex: 1,
    minWidth: 0,
  }),

  card: (theme) => ({
    ...styles.baseCard(theme),
    backgroundColor: theme.palette.grey.lighter4,
  }),

  whiteCard: (theme) => ({
    ...styles.baseCard(theme),
    backgroundColor: theme.palette.common.white,
  }),

  infoCard: (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    backgroundColor: theme.palette.grey.lighter4,
    borderRadius: "10px",
    padding: "16px 20px",
    width: "fit-content",
  }),

  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  infoIconWrapper: (theme) => ({
    width: 44,
    height: 44,
    borderRadius: "50%",
    backgroundColor: alpha(theme.palette.info.main, 0.125),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  }),

  iconImg: {
    width: "32px",
    height: "auto",
  },

  infoIconImg: {
    width: "38px",
    height: "auto",
  },

  textGroup: {
    display: "flex",
    flexDirection: "column",
  },

  title: (theme) => ({
    color: theme.palette.text.primary,
    lineHeight: 1.3,
    mb: 0.5,
  }),

  subtitle: (theme) => ({
    color: theme.palette.text.secondary,
    lineHeight: 1.3,
  }),

  infoText: (theme) => ({
    color: theme.palette.text.lighter4,
    lineHeight: 1.5,
  }),

  link: (theme) => ({
    color: theme.palette.primary.blueBright,
    cursor: "pointer",
    lineHeight: 1.3,
  }),
}
